import { AppRoute } from '../../../core/routing/AppRoute';
import { AuthGuard } from '../../common/rest-api/services/auth-guard.service';

// A feature route should be used in the App routing module in most cases and primarily provide
// a base url and module loading functionality.
// The feature route should employ a load children callback that loads the appropriate module
const Feature = new AppRoute({
  segment: 'garment-listing',
  title: 'Garment Listings',
  // A component can also be included to be the content, or a separate route with a blank segment
  // can be defined like below to provide a dedicated route instance
  // component: GarmentListingPage,
  loadChildren: () => import('./garment-listing.module').then(m => m.GarmentListingModule),
  canActive: [AuthGuard]
});

// "Sub-routes" should be the contentful endpoints for the feature. To provide content at the base
// level of the feature url, simply leave segment blank.
// Provide the parent parameter to be able to derive the fullPath of a route that includes the base

// TODO [EMP] Remove test/examples after examples and/or documentation is created
// To provide content at a sub url of the base, enter the appropriate endpoint in segment (not including the feature base url)




export const GarmentListingRoutes = {
  Feature: Feature,
}